// src/components/modals/ConfirmMultiDeleteModal.jsx
import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import "./ObjectExplorerModals.css";

export default function ConfirmMultiDeleteModal({
  show,
  onHide,
  onConfirm,
  selectedKeys = [] // valor padrão, nunca undefined!
}) {
  return (
    <Modal show={show} onHide={onHide} centered className="object-modal">
      <Modal.Header closeButton>
        <Modal.Title>Excluir Selecionados</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedKeys.length === 0 ? (
          <div>Nenhum item selecionado para exclusão.</div>
        ) : (
          <>
            <div className="object-modal-callout">
              <p className="mb-0">
                Tem certeza que deseja excluir <strong>{selectedKeys.length}</strong> item(ns)?
              </p>
            </div>
            <ul className="object-modal-list" style={{ fontSize: 13 }}>
              {selectedKeys.slice(0, 10).map((key, i) => (
                <li key={i} style={{ wordBreak: 'break-all' }}>{key}</li>
              ))}
              {selectedKeys.length > 10 && <li>...e mais {selectedKeys.length - 10} arquivo(s)</li>}
            </ul>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button
          variant="danger"
          onClick={onConfirm}
          disabled={selectedKeys.length === 0}
        >
          Excluir
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
